module.exports = __webpack_public_path__ + "static/media/top-img_6.e6d06bf6.jpg";